import {useCallback, useState} from "react";

export const useCountTime = () => {
    const [time, setTime] = useState("00:00");
    const [id, setId] = useState();
    const start = useCallback(() => {
        let t = 0;
        setId(setInterval(function () {
            t = t + 1;
            let minutes = parseInt(`${t / 60}`, 10);
            let seconds = parseInt(`${t % 60}`, 10);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            setTime(`${minutes}:${seconds}`)
        }, 1000));
    }, []);
    const stop = useCallback(() => {
        clearInterval(id);
        setTime("00:00")
    }, [id])
    return [time, start, stop]
}